  function slideDown(t, e = 300, i = 'block', r = !0) {
    let o = window.getComputedStyle(t).display;
    (r && 'none' !== o) ||
      (t.style.removeProperty('display'),
      'none' === o && (o = i),
      (t.style.display = o),
      (r = t.offsetHeight),
      (t.style.overflow = 'hidden'),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      t.offsetHeight,
      (t.style.transitionProperty = 'height, margin, padding'),
      (t.style.transitionDuration = e + 'ms'),
      (t.style.height = r + 'px'),
      t.style.removeProperty('padding-top'),
      t.style.removeProperty('padding-bottom'),
      t.style.removeProperty('margin-top'),
      t.style.removeProperty('margin-bottom'),
      window.setTimeout(() => {
        t.style.removeProperty('height'),
          t.style.removeProperty('overflow'),
          t.style.removeProperty('transition-duration'),
          t.style.removeProperty('transition-property');
      }, e));
  }
  function slideUp(t, e = 300) {
    (t.style.transitionProperty = 'height, margin, padding'),
      (t.style.transitionDuration = e + 'ms'),
      (t.style.height = t.offsetHeight + 'px'),
      t.offsetHeight,
      (t.style.overflow = 'hidden'),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      window.setTimeout(() => {
        (t.style.display = 'none'),
          t.style.removeProperty('height'),
          t.style.removeProperty('padding-top'),
          t.style.removeProperty('padding-bottom'),
          t.style.removeProperty('margin-top'),
          t.style.removeProperty('margin-bottom'),
          t.style.removeProperty('overflow'),
          t.style.removeProperty('transition-duration'),
          t.style.removeProperty('transition-property');
      }, e);
  }

  class Accordion extends HTMLElement {
    constructor() {
      super(),
        (this.button = this.querySelector('.accordion__button')),
        (this.targetName = this.button.getAttribute('aria-controls')),
        (this.target = this.querySelector('#' + this.targetName)),
        (this.accordionGroup = this.dataset.accordionGroup),
        this.target &&
          this.button.addEventListener('click', (t) => {
            t.preventDefault(),
              this.button.hasAttribute('data-inactive') ||
                (this.onButtonClick(), this.accordionGroup && this.closeAccordionGroup());
          });
    }
    closeAccordionGroup() {
      document.querySelectorAll(`[data-accordion-group=${this.accordionGroup}]`).forEach((t) => {
        t !== this && t.close();
      });
    }
    onButtonClick() {
      'true' === this.button.getAttribute('aria-expanded') ? this.close() : this.open();
    }
    open() {
      this.button.setAttribute('aria-expanded', 'true'),
        (this.button.style.pointerEvents = 'none'),
        slideDown(this.target),
        setTimeout(() => (this.button.style.pointerEvents = 'auto'), 300);
    }
    close() {
      this.button.setAttribute('aria-expanded', 'false'),
        (this.button.style.pointerEvents = 'none'),
        slideUp(this.target),
        setTimeout(() => (this.button.style.pointerEvents = 'auto'), 300);
    }
  }
  customElements.define('accordion-component', Accordion);